/**
 * MUESTRAS DE SORTEO — solo para desarrollo y para las capturas del gate G1.
 *
 * ⚠️ N1 · ACÁ NO HAY NI UN NÚMERO INVENTADO. Los cuatro documentos son la
 * conversión mecánica de lo que la fuente oficial publicó, a la forma exacta
 * que guarda `sorteos_juegos/{juegoClave}-{fechaISO}`:
 *
 *   lotoplus   sorteo 3909, 15/08/2026 — salida de `functions/sorteos/parser.js`
 *              corriendo sobre el fixture firmado con SHA-512
 *              `functions/sorteos/__fixtures__/LTO51X20260815.xml`
 *   loto5plus  sorteo 1457, 15/08/2026 — ídem sobre `LT551X20260815.xml`
 *   quini6     concurso 3401, 19/08/2026 — leído en vivo el 20/08/2026 de
 *              apps.loteriasantafe.gov.ar:8443/…/mostrarQuini6.xhtml?display=1
 *   brinco     concurso 1367, 16/08/2026 — ídem, mostrarBrinco.xhtml?display=1
 *
 * Los dos de Santa Fe se pasaron por un lector que mapea las columnas POR
 * NOMBRE de cabecera y nunca por posición, y que trata `VACANTE` como
 * `{ ganadores: 0, vacante: true }` con la nota del reglamento aparte. Son
 * las dos trampas que la spec marca en rojo para ese origen.
 *
 * Lo que NO está, y no se completó: `pozoEstimado` y `proximoSorteoISO` de
 * Quini 6 y de Brinco. La app de extractos de Santa Fe no los publica, así
 * que van en `null` y la cabecera de esos dos juegos se dibuja sin pozo y sin
 * próximo sorteo. Es el caso real, no un hueco de las muestras.
 *
 * ── Por qué esto no puede llegarle a un visitante ─────────────────────────
 *  1. `useExtractosJuegos` solo lo mira si `process.env.NODE_ENV` no es
 *     'production'. En el bundle de producción esa comparación queda como
 *     'production' !== 'production' y la rama se elimina.
 *  2. Además hay que pedirlo a mano, con `?muestra=1` en la URL.
 *  3. Y cuando está encendido, la vista dibuja una banda ámbar fija que dice
 *     que los datos son de muestra. Sin esa banda, una captura se podría
 *     confundir con un extracto publicado — que es exactamente el modo de
 *     falla que N1 existe para evitar.
 *
 * Generado el 20/08/2026. Cuando las reglas de Firestore estén desplegadas y
 * `JUEGOS_CON_EXTRACTO` deje de estar vacía, este archivo se puede borrar.
 */

/* eslint-disable */
export const MUESTRAS_SORTEO = {
  "lotoplus": {
    "sorteoId": "lotoplus-2026-08-15",
    "juegoClave": "lotoplus",
    "juegoNombre": "Loto Plus",
    "familia": "bolillero",
    "entidad": "Lotería de la Ciudad",
    "fuente": "loto.loteriadelaciudad.gob.ar",
    "fuenteVersion": "1",
    "sorteoNro": 3909,
    "concurso": 3909,
    "fecha": "15/08/2026",
    "fechaISO": "2026-08-15",
    "hora": "22:00",
    "prescripcionISO": "2026-09-16",
    "proximoSorteoISO": "2026-08-19",
    "proximoSorteoHora": "22:00",
    "pozoEstimado": 19965000000,
    "pozoEstimadoCrudo": "19965000000",
    "pozoEstimadoDudoso": false,
    "autoridades": [
      {
        "tipo": "Escribano",
        "nombre": "MITJANS, FERNANDO"
      },
      {
        "tipo": "Jefe de Sorteo",
        "nombre": "CORDOBA, LUCIANO MARTIN"
      }
    ],
    "modalidades": [
      {
        "clave": "plus",
        "nombre": "Número PLUS",
        "orden": 0,
        "numeros": [
          "06"
        ],
        "categorias": [
          {
            "clave": "6T",
            "etiqueta": null,
            "origen": "Premios",
            "pozo": 0,
            "ganadores": 0,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "5T",
            "etiqueta": null,
            "origen": "Premios",
            "pozo": null,
            "ganadores": null,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "4T",
            "etiqueta": null,
            "origen": "Premios",
            "pozo": null,
            "ganadores": null,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "6M",
            "etiqueta": null,
            "origen": "Premios",
            "pozo": 0,
            "ganadores": 0,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "5M",
            "etiqueta": null,
            "origen": "Premios",
            "pozo": null,
            "ganadores": null,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "4M",
            "etiqueta": null,
            "origen": "Premios",
            "pozo": null,
            "ganadores": null,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "6D",
            "etiqueta": null,
            "origen": "Premios",
            "pozo": 0,
            "ganadores": 0,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "SS",
            "etiqueta": null,
            "origen": "Premios",
            "pozo": 0,
            "ganadores": 0,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": false,
            "nota": null
          }
        ],
        "aciertos": null,
        "desconocida": false
      },
      {
        "clave": "tradicional",
        "nombre": "Tradicional",
        "orden": 1,
        "numeros": [
          "24",
          "04",
          "36",
          "40",
          "31",
          "29"
        ],
        "categorias": [
          {
            "clave": "01",
            "etiqueta": null,
            "origen": "Pozos",
            "pozo": 3455255110.5,
            "ganadores": 0,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "02",
            "etiqueta": null,
            "origen": "Pozos",
            "pozo": 19914147,
            "ganadores": 3,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "03",
            "etiqueta": null,
            "origen": "Pozos",
            "pozo": 3982829.4,
            "ganadores": 252,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": false,
            "nota": null
          }
        ],
        "aciertos": null,
        "desconocida": false
      },
      {
        "clave": "match",
        "nombre": "Match",
        "orden": 2,
        "numeros": [
          "03",
          "17",
          "09",
          "00",
          "27",
          "23"
        ],
        "categorias": [
          {
            "clave": "01",
            "etiqueta": null,
            "origen": "Pozos",
            "pozo": 1323155736.74,
            "ganadores": 0,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "02",
            "etiqueta": null,
            "origen": "Pozos",
            "pozo": 19914147,
            "ganadores": 23,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "03",
            "etiqueta": null,
            "origen": "Pozos",
            "pozo": 3982829.4,
            "ganadores": 797,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": false,
            "nota": null
          }
        ],
        "aciertos": null,
        "desconocida": false
      },
      {
        "clave": "desquite",
        "nombre": "Desquite",
        "orden": 3,
        "numeros": [
          "01",
          "33",
          "20",
          "06",
          "04",
          "39"
        ],
        "categorias": [
          {
            "clave": "01",
            "etiqueta": null,
            "origen": "Pozos",
            "pozo": 1829624708.8,
            "ganadores": 0,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": false,
            "nota": null
          }
        ],
        "aciertos": null,
        "desconocida": false
      },
      {
        "clave": "saleosale",
        "nombre": "Sale o Sale",
        "orden": 4,
        "numeros": [
          "41",
          "43",
          "02",
          "15",
          "21",
          "42"
        ],
        "categorias": [
          {
            "clave": "01",
            "etiqueta": null,
            "origen": "Pozos",
            "pozo": 51294015,
            "ganadores": 4,
            "premioUnitario": null,
            "aciertos": 5,
            "vacante": false,
            "nota": null
          }
        ],
        "aciertos": 5,
        "desconocida": false
      }
    ],
    "soloExtractoOficial": false,
    "extractoPdfUrl": "https://loto.loteriadelaciudad.gob.ar/export/descargaExtracto.php?sorteo=3909.pdf",
    "extractoUrl": null
  },
  "loto5plus": {
    "sorteoId": "loto5plus-2026-08-15",
    "juegoClave": "loto5plus",
    "juegoNombre": "Loto 5 Plus",
    "familia": "bolillero",
    "entidad": "Lotería de la Ciudad",
    "fuente": "loto.loteriadelaciudad.gob.ar",
    "fuenteVersion": "1",
    "sorteoNro": 1457,
    "concurso": 1457,
    "fecha": "15/08/2026",
    "fechaISO": "2026-08-15",
    "hora": "22:30",
    "prescripcionISO": "2026-09-16",
    "proximoSorteoISO": "2026-08-22",
    "proximoSorteoHora": "22:30",
    "pozoEstimado": 60000000,
    "pozoEstimadoCrudo": "60.000.00000",
    "pozoEstimadoDudoso": false,
    "autoridades": [
      {
        "tipo": "Escribano",
        "nombre": "MITJANS, FERNANDO"
      },
      {
        "tipo": "Jefe de Sorteo",
        "nombre": "CORDOBA, LUCIANO MARTIN"
      }
    ],
    "modalidades": [
      {
        "clave": "unico",
        "nombre": "Único",
        "orden": 0,
        "numeros": [
          "07",
          "08",
          "16",
          "04",
          "01"
        ],
        "categorias": [
          {
            "clave": "01",
            "etiqueta": null,
            "origen": "Pozos",
            "pozo": 48338910,
            "ganadores": 0,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "02",
            "etiqueta": null,
            "origen": "Pozos",
            "pozo": 4103100,
            "ganadores": 17,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "03",
            "etiqueta": null,
            "origen": "Pozos",
            "pozo": 3897945,
            "ganadores": 603,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": false,
            "nota": null
          }
        ],
        "aciertos": null,
        "desconocida": false
      }
    ],
    "soloExtractoOficial": false,
    "extractoPdfUrl": null,
    "extractoUrl": null
  },
  "quini6": {
    "sorteoId": "quini6-2026-08-19",
    "juegoClave": "quini6",
    "juegoNombre": "Quini 6",
    "familia": "bolillero",
    "entidad": "Lotería de Santa Fe",
    "fuente": "apps.loteriasantafe.gov.ar",
    "fuenteVersion": null,
    "sorteoNro": 3401,
    "concurso": 3401,
    "fecha": "19/08/2026",
    "fechaISO": "2026-08-19",
    "hora": null,
    "prescripcionISO": null,
    "proximoSorteoISO": null,
    "proximoSorteoHora": null,
    "pozoEstimado": null,
    "pozoEstimadoCrudo": null,
    "pozoEstimadoDudoso": false,
    "autoridades": [],
    "modalidades": [
      {
        "clave": "tradicional",
        "nombre": "Tradicional Primer Sorteo",
        "orden": 0,
        "numeros": [
          "01",
          "02",
          "06",
          "10",
          "17",
          "25"
        ],
        "categorias": [
          {
            "clave": "1",
            "etiqueta": "1° Premio",
            "origen": "tabla",
            "pozo": 1100000000,
            "ganadores": 0,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": true,
            "nota": "*El pozo se acumula para el primer premio del concurso siguiente según artículo 23° del reglamento"
          },
          {
            "clave": "2",
            "etiqueta": "2° Premio",
            "origen": "tabla",
            "pozo": 39065076,
            "ganadores": 71,
            "premioUnitario": 550212.34,
            "aciertos": null,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "3",
            "etiqueta": "3° Premio",
            "origen": "tabla",
            "pozo": 11719522.8,
            "ganadores": 2845,
            "premioUnitario": 4119.34,
            "aciertos": null,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "estimulo",
            "etiqueta": "Estímulo",
            "origen": "tabla",
            "pozo": 11000000,
            "ganadores": 0,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": true,
            "nota": "*El pozo se acumula para el primer premio del concurso siguiente según artículo 23° del reglamento"
          }
        ],
        "aciertos": null,
        "desconocida": false
      },
      {
        "clave": "segunda",
        "nombre": "Tradicional La Segunda del Quini",
        "orden": 1,
        "numeros": [
          "03",
          "10",
          "12",
          "16",
          "26",
          "33"
        ],
        "categorias": [
          {
            "clave": "1",
            "etiqueta": "1° Premio",
            "origen": "tabla",
            "pozo": 1100000000,
            "ganadores": 0,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": true,
            "nota": "*El pozo se acumula para el primer premio del concurso siguiente según artículo 23° del reglamento"
          },
          {
            "clave": "2",
            "etiqueta": "2° Premio",
            "origen": "tabla",
            "pozo": 39065076,
            "ganadores": 47,
            "premioUnitario": 831171.83,
            "aciertos": null,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "3",
            "etiqueta": "3° Premio",
            "origen": "tabla",
            "pozo": 11719522.8,
            "ganadores": 2258,
            "premioUnitario": 5190.22,
            "aciertos": null,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "estimulo",
            "etiqueta": "Estímulo",
            "origen": "tabla",
            "pozo": 11000000,
            "ganadores": 0,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": true,
            "nota": "*El pozo se acumula para el primer premio del concurso siguiente según artículo 23° del reglamento"
          }
        ],
        "aciertos": null,
        "desconocida": false
      },
      {
        "clave": "revancha",
        "nombre": "Revancha",
        "orden": 2,
        "numeros": [
          "02",
          "12",
          "14",
          "24",
          "29",
          "40"
        ],
        "categorias": [
          {
            "clave": "1",
            "etiqueta": "1° Premio",
            "origen": "tabla",
            "pozo": 4324127587.2,
            "ganadores": 0,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": true,
            "nota": "*El pozo se acumula para el primer premio del concurso siguiente según artículo 23° del reglamento"
          },
          {
            "clave": "estimulo",
            "etiqueta": "Estímulo",
            "origen": "tabla",
            "pozo": 47525598.72,
            "ganadores": 0,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": true,
            "nota": "*El pozo se acumula para el primer premio del concurso siguiente según artículo 23° del reglamento"
          }
        ],
        "aciertos": null,
        "desconocida": false
      },
      {
        "clave": "siempresale",
        "nombre": "Siempre Sale",
        "orden": 3,
        "numeros": [
          "07",
          "21",
          "27",
          "30",
          "32",
          "37"
        ],
        "categorias": [
          {
            "clave": "1",
            "etiqueta": "1° Premio",
            "origen": "tabla",
            "pozo": 350309772,
            "ganadores": 30,
            "premioUnitario": 11676992.4,
            "aciertos": 5,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "estimulo",
            "etiqueta": "Estímulo",
            "origen": "tabla",
            "pozo": 3503097.72,
            "ganadores": 0,
            "premioUnitario": 0,
            "aciertos": 0,
            "vacante": false,
            "nota": null
          }
        ],
        "aciertos": null,
        "desconocida": false
      },
      {
        "clave": "extra",
        "nombre": "Premio Extra",
        "orden": 4,
        "numeros": [
          "01",
          "02",
          "02",
          "03",
          "06",
          "10",
          "10",
          "12",
          "12",
          "14",
          "16",
          "17",
          "24",
          "25",
          "26",
          "29",
          "33",
          "40"
        ],
        "categorias": [
          {
            "clave": "1",
            "etiqueta": null,
            "origen": "tabla",
            "pozo": 200000000,
            "ganadores": 961,
            "premioUnitario": 208116.55,
            "aciertos": null,
            "vacante": false,
            "nota": null
          }
        ],
        "aciertos": null,
        "desconocida": false
      }
    ],
    "soloExtractoOficial": false,
    "extractoPdfUrl": null,
    "extractoUrl": null
  },
  "brinco": {
    "sorteoId": "brinco-2026-08-16",
    "juegoClave": "brinco",
    "juegoNombre": "Brinco",
    "familia": "bolillero",
    "entidad": "Lotería de Santa Fe",
    "fuente": "apps.loteriasantafe.gov.ar",
    "fuenteVersion": null,
    "sorteoNro": 1367,
    "concurso": 1367,
    "fecha": "16/08/2026",
    "fechaISO": "2026-08-16",
    "hora": null,
    "prescripcionISO": null,
    "proximoSorteoISO": null,
    "proximoSorteoHora": null,
    "pozoEstimado": null,
    "pozoEstimadoCrudo": null,
    "pozoEstimadoDudoso": false,
    "autoridades": [],
    "modalidades": [
      {
        "clave": "extracciones",
        "nombre": "Extracciones",
        "orden": 0,
        "numeros": [
          "09",
          "16",
          "19",
          "20",
          "36",
          "39"
        ],
        "categorias": [
          {
            "clave": "1",
            "etiqueta": "1° Premio",
            "origen": "tabla",
            "pozo": null,
            "ganadores": 0,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": true,
            "nota": "*Dicho pozo pasa a incrementar el primer premio del concurso siguiente según artículo 33º del reglamento"
          },
          {
            "clave": "2",
            "etiqueta": "2° Premio",
            "origen": "tabla",
            "pozo": null,
            "ganadores": 3,
            "premioUnitario": 2134646.23,
            "aciertos": null,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "3",
            "etiqueta": "3° Premio",
            "origen": "tabla",
            "pozo": null,
            "ganadores": 250,
            "premioUnitario": 8453.2,
            "aciertos": null,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "4",
            "etiqueta": "4° Premio",
            "origen": "tabla",
            "pozo": null,
            "ganadores": 3904,
            "premioUnitario": 1500,
            "aciertos": null,
            "vacante": false,
            "nota": null
          },
          {
            "clave": "estimulo",
            "etiqueta": "Estímulo",
            "origen": "tabla",
            "pozo": null,
            "ganadores": 0,
            "premioUnitario": null,
            "aciertos": null,
            "vacante": true,
            "nota": "*Dicho pozo pasa a incrementar el primer premio del concurso siguiente según artículo 33º del reglamento"
          }
        ],
        "aciertos": null,
        "desconocida": false
      },
      {
        "clave": "junior",
        "nombre": "Brinco Junior Siempre Sale",
        "orden": 1,
        "numeros": [
          "09",
          "24",
          "25",
          "26",
          "33",
          "37"
        ],
        "categorias": [
          {
            "clave": "1",
            "etiqueta": "1° Premio",
            "origen": "tabla",
            "pozo": 32009646.42,
            "ganadores": 2,
            "premioUnitario": 16004823.21,
            "aciertos": 5,
            "vacante": false,
            "nota": null
          }
        ],
        "aciertos": null,
        "desconocida": false
      }
    ],
    "soloExtractoOficial": false,
    "extractoPdfUrl": null,
    "extractoUrl": null
  }
};
